import { TFunction } from 'i18next'
import { z } from 'zod'

export const makeBrivoConnectionSchema = (t: TFunction<['organisation', 'common']>) =>
  z.object({
    apiKey: z.string().min(1, t('organisation:places.integrations.brivo.errors.apiKey')),
    clientId: z.string().min(1, t('organisation:places.integrations.brivo.errors.clientId')),
    clientSecret: z
      .string()
      .min(1, t('organisation:places.integrations.brivo.errors.clientSecret')),
    password: z.string().min(1, t('organisation:places.integrations.brivo.errors.password')),
    sdkClientId: z.string().min(1, t('organisation:places.integrations.brivo.errors.sdkClientId')),
    sdkClientSecret: z
      .string()
      .min(1, t('organisation:places.integrations.brivo.errors.sdkClientSecret')),
    username: z.string().min(1, t('organisation:places.integrations.brivo.errors.username')),
  })

export type BrivoConnectionFormValues = z.infer<ReturnType<typeof makeBrivoConnectionSchema>>

export const brivoDefaultValues: BrivoConnectionFormValues = {
  apiKey: '',
  clientId: '',
  clientSecret: '',
  password: '',
  sdkClientId: '',
  sdkClientSecret: '',
  username: '',
}
